<div class="modal-header">
    {{ id ? 'Ürün Varyantını Güncelle' : 'Yeni Ürün Varyantı Ekle' }}
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <form [formGroup]="productVariantForm">
        <div class="row">
            <div class="col-md-6 mb-3">
                <label class="form-label">Ad <span class="text-danger">*</span></label>
                <input type="text" class="form-control" formControlName="name" placeholder="Varyant adı">
                <div *ngIf="productVariantForm.get('name')?.invalid && productVariantForm.get('name')?.errors"
                    class="text-danger small mt-1">
                    <div *ngIf="productVariantForm.get('name')?.errors?.['required']">Ad alanı zorunludur</div>
                    <div *ngIf="productVariantForm.get('name')?.errors?.['minlength']">En az 2 karakter olmalıdır</div>
                    <div *ngIf="productVariantForm.get('name')?.errors?.['maxlength']">En fazla 100 karakter olmalıdır
                    </div>
                </div>
            </div>

            <div class="col-md-6 mb-3">
                <label class="form-label">İkinci Ad</label>
                <input type="text" class="form-control" formControlName="secondName"
                    placeholder="Buraya girdiğiniz isim pdfde görüneceketir">
            </div>
        </div>

        <div class="row">
            <div class="col-md-6 mb-3">
                <label class="form-label">Varyant Tipi <span class="text-danger">*</span></label>
                <select class="form-control" formControlName="variantType">
                    <option selected>Seçiniz</option>
                    <option *ngFor="let item of variantTypes" [value]="item.id">{{item.name}}</option>
                </select>
                <div *ngIf="productVariantForm.get('variantType')?.invalid && productVariantForm.get('variantType')?.errors?.['required']"
                    class="text-danger small mt-1">
                    Varyant tipi seçimi zorunludur
                </div>
            </div>

            <div class="col-md-6 mb-3">
                <!-- <div class="form-check mt-4">
                    <input class="form-check-input" type="checkbox" formControlName="isActive" id="isActive">
                    <label class="form-check-label" for="isActive">Aktif</label>
                </div> -->


                <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="customCheck1" formControlName="isActive" />
                    <label class="custom-control-label" for="customCheck1">Aktif</label>
                </div>
            </div>
        </div>

        <!-- Varyant Tipi Önizleme -->
        <div class="row" *ngIf="productVariantForm.get('variantType')?.value">
            <div class="col-12 mb-3">
                <label class="form-label">Önizleme</label>
                <div class="border rounded p-1">
                    <!-- Select Tipi -->
                    <div *ngIf="productVariantForm.get('variantType')?.value === '1'">
                        <select class="form-control" disabled>
                            <option>Örnek seçenek</option>
                        </select>
                    </div>

                    <!-- Checkbox Tipi -->
                    <div *ngIf="productVariantForm.get('variantType')?.value === '2'">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" disabled>
                            <label class="form-check-label">Örnek seçenek</label>
                        </div>
                    </div>

                    <!-- Text Tipi -->
                    <div *ngIf="productVariantForm.get('variantType')?.value === '3'">
                        <input type="text" class="form-control" placeholder="Metin girişi" disabled>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="closeModal()">İptal</button>
    <button type="button" class="btn btn-primary" [disabled]="productVariantForm.invalid"
        (click)="id ? updateProductVariantDefinition() : createProductVariantDefinition()">
        {{ id ? 'Güncelle' : 'Kaydet' }}
    </button>
</div>